import { useNavigate, useParams } from '@tanstack/react-router';
import { QrPairingView } from './QrPairingView';

/**
 * Deeplink standalone pra pareamento QR — útil pra abrir em aba dedicada
 * ou compartilhar URL. UX primária está no QrConnectModal (wizard 2 stages
 * em ChannelsPage). Esta página apenas envelopa QrPairingView.
 *
 * Tech-spec: (removido — vide whatsmeow worker) (Task H2).
 */
export function ConnectQrPage(): JSX.Element {
  const { numberId } = useParams({ strict: false }) as { numberId: string };
  const navigate = useNavigate();

  return (
    <div className="flex h-full items-center justify-center bg-n-50">
      <div className="w-[420px] rounded-lg border border-n-200 bg-n-0 p-8 shadow-md">
        <h1 className="mb-2 text-center font-bold text-[18px] text-n-900">
          Conectar via QR Code
        </h1>
        <p className="mb-6 text-center text-[12px] text-n-500">
          Canal não-oficial (WhatsApp Web).
        </p>
        <QrPairingView
          numberId={Number(numberId)}
          onClose={() => navigate({ to: '/canais' as any })}
        />
      </div>
    </div>
  );
}
